<script setup>
import { ref } from "vue";
import clientConfig from "/src/config/client";
import FooterSection from "/src/components/FooterSection.vue";
import HeaderSection from "/src/components/HeaderSection.vue";
import ProjectElement from "./../ProjectElement.vue";
import { onMounted } from "vue";
import AOS from "aos";
import TeamElement from "./../TeamElement.vue";

onMounted(() => {
  AOS.init();
});
const filterProjects = ref("Cyber");
const jobs = ref(clientConfig.content.jobs);

// const firstIsActive = ref(false);
// const secondIsActive = ref(false);
// const thirdIsActive = ref(false);

const filterDivision = ref("Cyber");
const people = ref(clientConfig.content.people);
</script>

<template>
  <HeaderSection />

  <main id="main">
    <section id="cyber-insurance" class="product-page-layout">
      <div class="overlay">
        <div class="container" data-aos="zoom-in">
          <header class="d-flex">
            <h2>
              <b>Cyber</b><br />
              Insurance
            </h2>
            <img src="@/assets/img/pen/cyber.png" />
          </header>
          <p class="highlight main-text pb-5 pt-2">
            We offer broad coverage including Breach costs | BI | extortion and
            ransomware | Network security, privacy liability | eTheft
          </p>

          <h3 class="highlight">Industries & Occupations</h3>

          <section class="industry">
            <div class="industry-list row justify-content-left">
              <div class="card col-6 col-md-4 industry-card">
                <div class="card-body p-3">
                  <h5 class="card-title mt-4">Preferred Occupations</h5>
                  <li>Architects / Engineers</li>
                  <li>Charities / Not for profit</li>
                  <li>Construction</li>
                  <li>Domestic Services</li>
                  <li>Education</li>
                  <li>Financial Institutions</li>
                  <li>Government</li>
                  <li>Hotels / Hospitality</li>
                  <li>Logistics / Freight Forwarder</li>
                  <li>Manufacturing</li>
                  <li>Real Estate</li>
                  <li>Recruitment</li>
                  <li>Retail</li>
                  <li>Wholesale</li>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h3 class="highlight my-4">Our Underwriters</h3>
            <div class="underwriters-wrapper row xs-justify-content-center">
              <TeamElement
                v-for="member in people"
                :key="member"
                :name="member.name"
                :division="member.division"
                :role="member.role"
                :mobile="member.mobile"
                :mobileUrl="member.mobileUrl"
                :phone="member.phone"
                :phoneUrl="member.phoneUrl"
                :email="member.email"
                :imageUrl="member.imageUrl"
                :location="member.location"
                v-show="member.division == filterDivision"
              />
            </div>
          </section>

          <section class="projects section-bg">
            <h3>Recent Wins</h3>
            <div class="recent-wins">
              <div
                v-if="filterProjects != 'All'"
                class="row xs-justify-content-center"
              >
                <ProjectElement
                  v-for="job in jobs"
                  :key="job"
                  :title="job.title"
                  :type="job.type"
                  v-show="job.type == filterProjects"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </main>

  <FooterSection />
</template>
